import { Box, Grid, Toolbar, Typography } from "@mui/material";
import React from "react";
import { LOCALE } from "../../properties/Locale";
import { useSelector } from "react-redux";
import { useTheme } from "@emotion/react";

export default function Footer() {
  const auth = useSelector((state) => state.auth);
  const theme = useTheme();

  return (
    <Toolbar
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        zIndex: 0,
        padding: "10px 20px",
        position: "relative",
      }}
    >
      <Grid container sx={{ flexGrow: 1 }}>
        <Grid item xs={7}>
          <Box
            sx={{
              position: "absolute",
              left: 0,
              top: 0,
              height: "100%",
              width: "830px",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              "&::after": {
                content: '""',
                position: "absolute",
                right: 0,
                top: 0,
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(to left, rgba(255,255,255,1), rgba(255,255,255,0))",
                zIndex: 1,
              },
            }}
          >
            {Array.from({ length: 10 }).map((_, i) => (
              <Box
                key={i}
                sx={{
                  width: "83px",
                  height: "100%",
                  background: `linear-gradient(-45deg, #f0dec4a8 50%, transparent 0), linear-gradient(45deg, #5c95f180 50%, transparent 0)`,
                  opacity: 0.3,
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>
    </Toolbar>
  );
}
